import React from 'react';
import { DependencyList, EffectCallback } from 'react';

/**
 * Bypasses React strict mode. NOTE: only to be used with components that really need it e.g. map and related services. Overuse will be punished! Strict mode exist for a reason.
 * In prod mode points to {@link React.useEffect}
 */
export const useSafeEffect = import.meta.env.DEV ? _safeEffect : React.useEffect;

type Destructor = () => void;
function _safeEffect(effect: EffectCallback, deps?: DependencyList) {
    React.useEffect(() => {
        let mounted = true;
        let destructor: void | Destructor | null = null;
        Promise.resolve().then(() => {
            if (mounted) {
                destructor = effect();
            }
        });
        return () => {
            mounted = false;
            destructor?.();
        };
    }, deps);
}
